import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-crear-solicitud-validacion-ref',
  templateUrl: './crear-solicitud-validacion-ref.component.html',
  styleUrls: ['./crear-solicitud-validacion-ref.component.scss'],
})
export class CrearSolicitudValidacionRefComponent implements OnInit {
  form: FormGroup;

  tipo_validaciones = ['Cheque de Gerencia', 'Transferencia Interbancaria'];
  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      ente_solicitante: [
        values ? values.ente_solicitante : '',
        [Validators.required],
      ],
      fecha_solicitud: [
        values ? values.fecha_solicitud : '',
        [Validators.required],
      ],
      nombre_apellido: [
        values ? values.nombre_apellido : '',
        [Validators.required],
      ],
      ci_solicitante: [
        values ? values.ci_solicitante : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      cargo_solicitante: [
        values ? values.cargo_solicitante : '',
        [Validators.required],
      ],
      area_labor_solicitante: [
        values ? values.area_labor_solicitante : '',
        [Validators.required],
      ],
      ci_a_validar: [
        values ? values.ci_a_validar : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      nombre_apellido_validar: [
        values ? values.nombre_apellido_validar : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
